/* eslint-disable unicorn/filename-case */
// Signature Profiles public page entry
// Add <%= javascript_pack_tag "signature-profiles" %> in erb view to use this bundle

// Import Tailwind CSS styles
// eslint-disable-next-line import/no-internal-modules
import "user_site/main.css";

// eslint-disable-next-line import/no-internal-modules
import "../user_site/lib/react-query";

const componentRequireContext = require.context(
  "user_site/rails-components",
  true
);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const ReactRailsUjs = require("react_ujs");

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUjs.useContext(componentRequireContext);
